import Footer from "@/components/footers/Footer";

type AuthPageShellProps = {
    children: React.ReactNode;
};

const AuthPageShell = ({ children }: AuthPageShellProps) => {
    return (
        <div className="gs-auth-page">
            <div className="gs-auth-body">
                <div className="gs-auth-form-wrap">{children}</div>
                <Footer />
            </div>
        </div>
    );
};

export default AuthPageShell;
